module.exports = __webpack_public_path__ + "static/media/p10.c872b410.png";